firebird.factory('customerSupportService', [
    '$rootScope',
    'attendeeService',
    'meetingService',
    '$window',
    '$http',
    'logService',
    'brandingService',
    'helperService',
    function ($rootScope, attendeeService, meetingService, $window, $http, logService, brandingService, helperService) {
        var snapEngageCodeHasBeenAdded = false;
        var agentStatusCheckingIntervalId;

        // SnapEngage widget ids
        var anyMeetingWidgetId = '90d80640-606c-4fd8-bbc9-edb5e03226a7';
        var interMediaDirectWidgetId = '12a34424-3995-4935-a82a-5292d4981e9a';
        var interMediaPLRWebinarWidgetId = '65f5e8be-7ab9-4977-bf6f-1719adcdf0c2';

        let ODAAgentStatusCheckingIntervalId;
        let ODAAgentQueueStatsRetry = false;
        const qaODAConfig = {
            authUrl:
                'https://tst3.qa.support.intermedia.com/services/rest/crossChannelServices/latest/establishSessions',
            queueStatsUrl:
                'https://bcvipac02.rightnowtech.com/engagement/api/consumer/intermedia__tst3/v1/getQueueStats',
            queueId: 65
        };
        const prodODAConfig = {
            authUrl: 'https://support.intermedia.com/services/rest/crossChannelServices/latest/establishSessions',
            queueStatsUrl: 'https://bcvipac02.rightnowtech.com/engagement/api/consumer/intermedia/v1/getQueueStats',
            AuthHeader: 'Basic T0RBX0FOWU1FRVRJTkdfVVNFUjptVElONmFELW0xTg==',
            queueId: 65
        };

        var service = {
            enableSnapEngageLiveSupportWidget: enableSnapEngageLiveSupportWidget,
            disableSnapEngageLiveSupportWidget: disableSnapEngageLiveSupportWidget,
            hideButton: hideButton,
            openCustomerSupport: openCustomerSupport,
            canLoadSnapEngage: canLoadSnapEngage,
            initODAChatWidget: initODAChatWidget,
            canUseODACustomerService: canUseODACustomerService,
            getODAAgentQueueStats: getODAAgentQueueStats,
            ODACleanUp: ODACleanUp
        };

        $rootScope.$on('disable-snap-engage-live-support', service.disableSnapEngageLiveSupportWidget);

        return service;

        ////////////////////////

        function loadSnapEngageLiveSupportWidget() {
            if (snapEngageCodeHasBeenAdded === true) {
                logService.log('customerSupportService##loadSnapEngageLiveSupportWidget#startAgentStatusChecking');
                startAgentStatusChecking();
            } else {
                if (canLoadSnapEngage()) {
                    logService.log(
                        'customerSupportService##loadSnapEngageLiveSupportWidget#Adding Live Support Chat Widget...'
                    );

                    // Mark that we are adding the SnapEngage widget code
                    snapEngageCodeHasBeenAdded = true;

                    // begin SnapEngage code
                    (function () {
                        var se = document.createElement('script');
                        se.type = 'text/javascript';
                        se.async = true;
                        se.src = getSnapEngageJSPath();

                        var done = false;
                        var seInit = false;
                        se.onload = se.onreadystatechange = function () {
                            if (
                                !done &&
                                (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')
                            ) {
                                done = true;
                                /* Place your SnapEngage JS API code below */
                                /* SnapEngage.allowChatSound(true); Example JS API: Enable sounds for Visitors. */

                                hideButton();

                                startAgentStatusChecking();

                                $window.SnapEngage.setUserEmail(attendeeService.getEmail());

                                $window.SnapEngage.setCallback('ChatMessageReceived', function (agent, msg) {
                                    if (seInit == false) {
                                        if (attendeeService.getIsHost() === true) {
                                            $window.SnapEngage.sendTextToChat('Account Owner');
                                        }
                                        seInit = true;
                                    }
                                });
                            }
                        };
                        var s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(se, s);
                    })();
                    // end SnapEngage code
                }
            }
        }

        function getSnapEngageJSPath() {
            var widgetId;
            if (meetingService.isIntermediaDirectUser()) {
                widgetId = interMediaDirectWidgetId;
            } else if (meetingService.isWebinar() && meetingService.isIntermediaPLRUser()) {
                widgetId = interMediaPLRWebinarWidgetId;
            } else {
                widgetId = anyMeetingWidgetId;
            }

            return '//storage.googleapis.com/code.snapengage.com/js/' + widgetId + '.js';
        }

        function hideButton() {
            if (
                $window.SnapEngage !== undefined &&
                $window.SnapEngage.hideButton !== undefined &&
                $window.SnapEngage.setCallback !== undefined
            ) {
                $window.SnapEngage.hideButton();
                $window.SnapEngage.setCallback('Close', function (type, status) {
                    $window.SnapEngage.hideButton();
                });
            }
        }

        function enableSnapEngageLiveSupportWidget() {
            loadSnapEngageLiveSupportWidget();
        }

        function disableSnapEngageLiveSupportWidget() {
            logService.log('customerSupportService##disableSnapEngageLiveSupportWidget');
            stopAgentStatusChecking();
            $rootScope.$broadcast('snapengage-agent-status', false);
        }

        // Check the widget status every 2 minutes
        function checkAgentStatus() {
            if (canUseSnapEngage()) {
                $window.SnapEngage.getAgentStatusAsync(function (online) {
                    logService.log('customerSupportService## ONLINE: ', online);
                    $rootScope.$broadcast('snapengage-agent-status', online);
                });
            }
        }

        function startAgentStatusChecking() {
            // Stop the interval if it is already running
            stopAgentStatusChecking();

            // Check the agent status right away
            checkAgentStatus();

            // Check again every 2 minutes
            agentStatusCheckingIntervalId = setInterval(checkAgentStatus, 120000); // 2 minutes (2 * 60 * 1000)
        }

        function stopAgentStatusChecking() {
            clearInterval(agentStatusCheckingIntervalId);
        }

        function openCustomerSupport() {
            logService.log('customerSupportService#openCustomerSupport called');
            if (canUseSnapEngage()) {
                $window.SnapEngage.startPreChat();
            }
        }

        function canUseSnapEngage() {
            logService.log(
                'customerSupportService#canUseSnapEngage - $window.SnapEngage is undefined: ',
                $window.SnapEngage === undefined
            );
            return $window.SnapEngage !== undefined && canLoadSnapEngage();
        }

        function canLoadSnapEngage() {
            var isPresenter = attendeeService.getIsPresenter();
            var featureList = meetingService.getFeatureList();
            var customerSupportEnabled = featureList.phoneCustomerSupport === 'enabled';

            return brandingService.isSnapEngageWidgetVisible() && isPresenter && customerSupportEnabled;
        }

        function initODAChatWidget() {
            if (!canUseODACustomerService()) {
                return;
            }

            const fullName = attendeeService.getScreenName().split(' ');
            const firstName = fullName[0];
            const lastName = fullName[fullName.length - 1] || '';

            initODASDK('Bots', helperService.getEnvironment(), firstName, lastName, attendeeService.getEmail());
            getODAAgentQueueStats();
        }

        function canUseODACustomerService() {
            var isPresenter = attendeeService.getIsPresenter();
            var featureList = meetingService.getFeatureList();
            var customerSupportEnabled = featureList.phoneCustomerSupport === 'enabled';

            return isPresenter && customerSupportEnabled && meetingService.isIntermediaDirectUser();
        }

        function getODAAgentQueueStats() {
            $http({
                method: 'POST',
                url: helperService.getEnvironment() == 'prod' ? prodODAConfig.queueStatsUrl : qaODAConfig.queueStatsUrl,
                data: {
                    queueId: helperService.getEnvironment() == 'prod' ? prodODAConfig.queueId : qaODAConfig.queueId,
                    chatProactiveAvailableType: 'AGENTS'
                },
                headers: {
                    'Content-Type': 'application/json',
                    'OSvC-CREST-Application-Context': 'getQueueStats AnyMeeting'
                }
            }).then(
                function successCallback(response) {
                    $rootScope.$broadcast('oda-live-chat-total-available-agents', response.data.totalAvailableAgents);
                    if (ODAAgentStatusCheckingIntervalId == undefined) {
                        // Check again every 2 minutes
                        ODAAgentStatusCheckingIntervalId = setInterval(function () {
                            getODAAgentQueueStats();
                        }, 120000); // 2 minutes (2 * 60 * 1000)
                    }
                },
                function errorCallback(response) {
                    logService.warn('customeerSupportService - getODAAgentQueueStats failed status: ', response.status);

                    if (!ODAAgentQueueStatsRetry) {
                        ODAAgentQueueStatsRetry = true;
                    }
                }
            );
        }

        function ODACleanUp() {
            if (Bots) {
                Bots.destroy();
            }
            clearInterval(ODAAgentStatusCheckingIntervalId);
        }
    }
]);
